import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=7a359fce&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7a359fce')) {
      api.createRecord('7a359fce', component.options)
    } else {
      api.reload('7a359fce', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=7a359fce&", function () {
      api.rerender('7a359fce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2HJMsOZtSTc2m/JS/cancellationPolicy.vue"
export default component.exports